import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { setLoader } from "../../ui/actions";
import ManhattanFactoryProducer from "../../../../factories/manhattan/bundle/ManhattanFactoryProducer";
import { getSessionData } from "../../sessionData/actions";
import { createErrorNotification, getNotification } from "../../notification/actions";
import { bundleValidatorAction, setManhattanBundleAction } from "./actions";
import { apiRequest } from '../../api/actions';
import { setErrorModeAction } from "../../redirection/actions";
import BundleValidator from "../../../../validators/bundle/BundleValidator";
import { IManhattanBundle } from '../../../../entities/manhattan/bundle/types';
import { getBundleDataAction } from '../bundleData/actions';
import { getPreBasket } from '../../preBasket/actions';
import { OrderTypes } from '../../../../constants/OrderTypes';

export const getStandardBundleMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.MANHATTAN.BUNDLE.FETCH:
    const bundleApiUrl = action.params.bundleProductLine ? `${ApiUrls.BUNDLES}/${action.params.bundleProductLine}/${action.params.bundleName}` : `${ApiUrls.BUNDLES}/${action.params.bundleName}`;
    next(apiRequest(
      null,
      'GET',
      bundleApiUrl,
      {
        options: action.params.options,
        lang: action.params.lang,
        section: action.params.section
      },
      null,
      MiddlewareEntities.MANHATTAN.BUNDLE,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.MANHATTAN.BUNDLE));
    break;
  case `${MiddlewareEntities.MANHATTAN.BUNDLE} ${ActionTypes.API_SUCCESS}` :
    next(bundleValidatorAction(action.payload.data));
    next(getSessionData(action.payload.data.session));
    if (action.payload.data.productLine.productLine === OrderTypes.BUNDLE_FTTH) {
      next(getPreBasket());
    }
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.MANHATTAN.BUNDLE));
    next(setLoader(false, MiddlewareEntities.MANHATTAN.BUNDLE));
    break;
  case `${MiddlewareEntities.MANHATTAN.BUNDLE} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.MANHATTAN.BUNDLE));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.MANHATTAN.BUNDLE));
    break;
  }
};

export const bundleValidatorMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => async (action: AnyAction) => {
  next(action);

  if (action.type.includes(ActionTypes.MANHATTAN.BUNDLE.VALIDATOR)) {
    if (await BundleValidator.validate(action.payload)) {
      const bundleFactory = ManhattanFactoryProducer.getProductFactory(action.payload.productLine.productLine);
      const bundle = bundleFactory.create(action.payload);
      next(getBundleDataAction(bundle as IManhattanBundle));
      return store.dispatch(setManhattanBundleAction(bundle));
    }
    return next(setErrorModeAction());
  }
};

export const getManhattanMiddleware = [
  getStandardBundleMiddleware,
  bundleValidatorMiddleware
];
